import type { ReactNode } from "react"
import companyFormStyles from "@/features/company/styles/companyAdd.module.css"

type TransferPaymentFieldProps = {
  children: ReactNode
  useCardLayout: boolean
}

export function TransferPaymentField({ children, useCardLayout }: TransferPaymentFieldProps) {
  return useCardLayout ? (
    <div className={companyFormStyles.formGroup}>{children}</div>
  ) : (
    <div className={companyFormStyles.formCol}>
      <div className={companyFormStyles.formGroup}>{children}</div>
    </div>
  )
}
